import Vue from 'vue';
import querystring from 'querystring';
import * as Articulos from '@lib/Articulos';
import { Watch } from 'vue-property-decorator';
import { Paginacion, Wait, Guid } from '@/__env/ext';
import { Utiles } from '@env/pluggins/event-bus';
import { SignalDispatcher, SimpleEventDispatcher, EventDispatcher } from 'strongly-typed-events';
import { VistaBase, FiltrosBase } from '@/components/a-interfaz/a-controlador';
import router from '@/__env/router.index';
import { CuentasMercadoLibre } from '@/__env/lib/MercadoLibre/Cuentas/Cuentas';

import * as Chats from '@/__env/lib/MercadoLibre/Chats';
import { Chat } from '@/__env/lib/MercadoLibre/Chats';
import { Mensaje } from '@/__env/lib/MercadoLibre/Chats/Mensajes';
import { Adjunto } from '@/__env/lib/MercadoLibre/Chats/Mensajes/Mensaje.lib';
import { ArchivoTemporal } from '@/__env/lib/Varios/Archivos/Temporal.nav';
import { Tipo } from '@/__env/lib/CuentasCorrientes/Movimientos/Tipos';
import { Cliente } from '@/__env/lib/Clientes';
import { Pedido } from '@/__env/lib/Ventas/Pedidos';


export class ControladorBarrasLaterales
{
    constructor( cliente: Cliente )
    {
        this.Cliente = cliente;
    }
    public Cliente: Cliente;
    public PedidoSeleccionado: Pedido = null;
    public ArchivoSeleccionado: string = null;
    public ModoDeArchivoSeleccionado: string = '';

    public async Iniciar()
    {
 
    }

 



    public Vista: VistaBase = new VistaBase();
 

    private _onRecargarMensaje = new SimpleEventDispatcher<any>();
    public get onRecargarMensaje() { return this._onRecargarMensaje.asEvent(); }

    private _onNuevoMensaje= new SimpleEventDispatcher<any>();
    public get onNuevoMensaje() { return this._onNuevoMensaje.asEvent(); }

    public ScrollYFocus()
    {
        this._onScrollYFocus.dispatch();
    }
    private _onScrollYFocus = new SignalDispatcher();
    public get onScrollYFocus() { return this._onScrollYFocus.asEvent(); }
}
